import React from "react"

import { CheckCircle, Home } from "lucide-react"
import { Link } from "react-router-dom"

import { Button } from "@/components/ui/button"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { useApplication } from "@/contexts/ApplicationContext"

const ApplicationComplete: React.FC = () => {
  const { application } = useApplication()

  return (
    <div className="container mx-auto max-w-lg px-4 py-6">
      <Card>
        <CardHeader className="text-center">
          <div className="mb-4 flex justify-center">
            <div className="rounded-full bg-green-100 p-3">
              <CheckCircle className="h-8 w-8 text-green-600" />
            </div>
          </div>
          <CardTitle className="text-xl font-bold text-jungle">Welcome Aboard!</CardTitle>
        </CardHeader>

        <CardContent className="space-y-4">
          <div className="rounded-lg border border-green-200 bg-green-50 p-4">
            <p className="mb-2 font-medium text-green-800">
              Congratulations! You're now part of the HIVED delivery network
            </p>
            <p className="text-sm text-green-700">
              You've successfully completed all onboarding steps and are now officially approved to
              operate with HIVED. Your HIVED ID is{" "}
              <span className="font-bold">{application.airtablePersonId}</span>.
            </p>
          </div>

          <div className="space-y-3">
            <h3 className="font-medium text-gray-900">You're all set to start!</h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li className="flex items-start">
                <span className="mr-3 mt-1.5 inline-block h-2 w-2 flex-shrink-0 rounded-full bg-green-500"></span>
                You've completed your orientation and onboarding
              </li>
              <li className="flex items-start">
                <span className="mr-3 mt-1.5 inline-block h-2 w-2 flex-shrink-0 rounded-full bg-green-500"></span>
                Your trial block met the required standards
              </li>
              <li className="flex items-start">
                <span className="mr-3 mt-1.5 inline-block h-2 w-2 flex-shrink-0 rounded-full bg-green-500"></span>
                All necessary documentation has been submitted and verified
              </li>
              <li className="flex items-start">
                <span className="mr-3 mt-1.5 inline-block h-2 w-2 flex-shrink-0 rounded-full bg-green-500"></span>
                You're now ready to start earning with HIVED!
              </li>
            </ul>
          </div>

          <div className="rounded-lg bg-gray-50 p-4">
            <p className="text-sm text-gray-600">
              Welcome to the network! You'll receive further instructions shortly about how to
              access the HIVED app and start accepting blocks.
            </p>
          </div>
        </CardContent>

        <div className="p-6 pt-0">
          <Link to="/" className="block w-full">
            <Button className="w-full bg-honeycomb hover:bg-amber-500">
              <Home className="mr-2 h-4 w-4" /> Return to Home
            </Button>
          </Link>
        </div>
      </Card>
    </div>
  )
}

export default ApplicationComplete
